import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './met-canal-communication.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const MetCanalCommunicationDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const metCanalCommunicationEntity = useAppSelector(state => state.metCanalCommunication.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="metCanalCommunicationDetailsHeading">
          <Translate contentKey="almobadaraMasterDataApp.metCanalCommunication.detail.title">MetCanalCommunication</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{metCanalCommunicationEntity.id}</dd>
          <dt>
            <span id="code">
              <Translate contentKey="almobadaraMasterDataApp.metCanalCommunication.code">Code</Translate>
            </span>
          </dt>
          <dd>{metCanalCommunicationEntity.code}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="almobadaraMasterDataApp.metCanalCommunication.name">Name</Translate>
            </span>
          </dt>
          <dd>{metCanalCommunicationEntity.name}</dd>
          <dt>
            <span id="nameAr">
              <Translate contentKey="almobadaraMasterDataApp.metCanalCommunication.nameAr">Name Ar</Translate>
            </span>
          </dt>
          <dd>{metCanalCommunicationEntity.nameAr}</dd>
          <dt>
            <span id="nameEn">
              <Translate contentKey="almobadaraMasterDataApp.metCanalCommunication.nameEn">Name En</Translate>
            </span>
          </dt>
          <dd>{metCanalCommunicationEntity.nameEn}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="almobadaraMasterDataApp.metCanalCommunication.status">Status</Translate>
            </span>
          </dt>
          <dd>{metCanalCommunicationEntity.status}</dd>
        </dl>
        <Button tag={Link} to="/met-canal-communication" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/met-canal-communication/${metCanalCommunicationEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default MetCanalCommunicationDetail;
